import {TERMS_CONDITIONS} from './types';
import {salomapi3} from '../apis';

export const fetchTerms =  (region) => async dispatch => {
    const response = await salomapi3.get('/termscondtions?region='+region);
    dispatch({type:TERMS_CONDITIONS,payload:response.data})
}